var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutMainPage",
    {
      class: [
        "cock-fight-body",
        { mobile: _vm.isMobile, freeze: _vm.isAnyPopupOpen },
      ],
      style: _vm.maxWidthStyle,
    },
    [
      _c(
        "section",
        {
          staticClass: "container",
          class: [
            _vm.getTheme(_vm.theme),
            {
              vertical: _vm.isMobileVertical,
              landscape: _vm.isMobileLandscape,
              sticky: _vm.isSticky,
            },
          ],
          on: { scroll: _vm.handleScroll },
        },
        [
          _c(
            "div",
            { staticClass: "left-panel" },
            [
              _vm.isUsingVePlayer
                ? _c("VePlayerVideo", {
                    key: "veplayer",
                    ref: "vePlayer",
                    class: {
                      "sticky-video": _vm.isSticky && _vm.isFloatingVideo,
                    },
                    attrs: {
                      videoPlayerReady: _vm.videoPlayerReady,
                      isAnyPopupOpen: _vm.isAnyPopupOpen,
                    },
                    on: { "playback-failed": _vm.onVePlayerPlaybackFailed },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "overlay",
                          fn: function () {
                            return [
                              _c("VideoToast", {
                                attrs: {
                                  toast: _vm.betVideoToast,
                                  source: _vm.arena.id,
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2257031425
                    ),
                  })
                : !_vm.isUsingV1Video
                ? _c("TCVideo", {
                    key: "tcvideo",
                    ref: "tcVideo",
                    class: {
                      "sticky-video": _vm.isSticky && _vm.isFloatingVideo,
                    },
                    attrs: {
                      videoPlayerReady: _vm.videoPlayerReady,
                      isAnyPopupOpen: _vm.isAnyPopupOpen,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "overlay",
                        fn: function () {
                          return [
                            _c("VideoToast", {
                              attrs: {
                                toast: _vm.betVideoToast,
                                source: _vm.arena.id,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  })
                : _c("TCVideoV1", {
                    key: "tcvideov1",
                    ref: "tcVideoV1",
                    class: {
                      "sticky-video": _vm.isSticky && _vm.isFloatingVideo,
                    },
                    attrs: {
                      videoPlayerReady: _vm.videoPlayerReady,
                      isAnyPopupOpen: _vm.isAnyPopupOpen,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "overlay",
                        fn: function () {
                          return [
                            _c("VideoToast", {
                              attrs: {
                                toast: _vm.betVideoToast,
                                source: _vm.arena.id,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
              _c("GameStatus", {
                staticClass: "game-status-mobile",
                attrs: { active: _vm.hasUncollectTicket },
                on: {
                  jackpotCollectPopup: _vm.collectJackpotHandler,
                  jackpotPhysicalPopup: function ($event) {
                    return _vm.openMenuPopup(_vm.PopupPage.jackpotPhysicalHelp)
                  },
                },
              }),
              !_vm.isMobile || _vm.isMobileLandscape
                ? [
                    _vm.chartFights && _vm.chartFights.length > 0
                      ? _c("Charts")
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "right-panel" },
            [
              _vm.isMobileLandscape || !_vm.isMobile
                ? _c("Notifications")
                : _vm._e(),
              _c("BetPanel", {
                attrs: { active: _vm.hasUncollectTicket },
                on: {
                  jackpotCollectPopup: _vm.collectJackpotHandler,
                  jackpotPhysicalPopup: function ($event) {
                    return _vm.openMenuPopup(_vm.PopupPage.jackpotPhysicalHelp)
                  },
                },
              }),
              _vm.isMobileLandscape
                ? _c(
                    "div",
                    { staticClass: "footer-landscape-wrapper" },
                    [_c("FooterLandscape")],
                    1
                  )
                : _vm._e(),
              _vm.isMobile && !_vm.isMobileLandscape
                ? [
                    _vm.chartFights && _vm.chartFights.length > 0
                      ? _c("Charts")
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _c("MenuPopup"),
      _c(
        "Popup",
        _vm._b(
          {
            ref: "jackpotCollectPopup",
            attrs: {
              active: _vm.isJackpotCollectionPopupOpen,
              animation: "fade",
              transparentBg: false,
              fullsize: false,
              hasBg: false,
              align: _vm.isMobile ? "center" : "right",
              borderRadiusBySide: ["16px", "16px", "16px", "16px"],
            },
            on: {
              close: function ($event) {
                _vm.isJackpotCollectionPopupOpen = false
              },
            },
          },
          "Popup",
          {
            modalContainerStyles: _vm.defaultJackpotCollectionContainerStyle,
          },
          false
        ),
        [
          _c("JackPotCollectionPopup", {
            on: { jackpotPopup: _vm.jackpotHandler },
          }),
        ],
        1
      ),
      _c(
        "Popup",
        _vm._b(
          {
            ref: "jackpotPopup",
            attrs: {
              active: _vm.isJackpotPopupOpen,
              animation: "fade",
              transparentBg: false,
              fullsize: false,
              align: "right",
              valign: "bottom",
              hasBg: false,
              showHeader: true,
              borderRadiusBySide: _vm.isMobile
                ? ["16px", "16px", "0", "0"]
                : ["16px", "0", "0", "16px"],
            },
            on: { close: _vm.toggleJackpotClose },
            scopedSlots: _vm._u([
              {
                key: "modalHeader",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "modal-header-wrapper" },
                      [
                        _c(
                          "Nav",
                          {
                            attrs: {
                              imageURL: _vm.activePopupPage,
                              toURL: _vm.toURL,
                              popupLevel: _vm.popupLevel(_vm.activePopupPage),
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t(_vm.activePopupPage)) + " "
                            ),
                          ]
                        ),
                        _vm.activePopupPage === _vm.PopupPage.jackpot
                          ? _c(
                              "div",
                              {
                                staticClass: "jackpot-nav-btns",
                                class: { "is-mobile": _vm.isMobile },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/jackpot-history.svg"),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateActivePopupPage(
                                        _vm.PopupPage.jackpotHistory
                                      )
                                    },
                                  },
                                }),
                                _vm.config.enableJackpot
                                  ? _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/jackpot-instant-prize.svg"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.updateActivePopupPage(
                                            _vm.PopupPage.jackpotHelp
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        !_vm.isMobile
                          ? _c(
                              "div",
                              {
                                staticClass: "close-btn",
                                on: { click: _vm.toggleJackpotClose },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/close.webp"),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          "Popup",
          {
            modalContainerStyles: _vm.defaultContainerStyle("jackpot"),
          },
          false
        ),
        [
          _vm.activePopupPage === _vm.PopupPage.jackpot
            ? _c("JackPotPopup")
            : _vm._e(),
          _vm.activePopupPage === _vm.PopupPage.jackpotHistory
            ? _c("JackpotLogs", {
                attrs: {
                  logTickets: _vm.ownerPayoutTicketsLog,
                  ticketsLength: _vm.ownerTicketsLog.length || 0,
                  hasHeader: "",
                },
                on: { loadMoreTickets: _vm.getOwnerTicketsLog },
              })
            : _vm._e(),
          _vm.activePopupPage === _vm.PopupPage.jackpotHelp
            ? _c("HelpContent", {
                attrs: { helpSource: _vm.luckyDrawInstantPrizeHelpGuide },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "Popup",
        _vm._b(
          {
            ref: "errorPopup",
            attrs: {
              active: _vm.isErrorPopupOpen,
              animation: "fade",
              transparentBg: false,
              fullsize: false,
              hasBg: false,
              align: _vm.isMobile ? "center" : "right",
              borderRadiusBySide: ["16px", "16px", "16px", "16px"],
            },
            on: { close: _vm.toggleErrorPopupClose },
          },
          "Popup",
          {
            modalContainerStyles: _vm.defaultErrorMessageStyle,
          },
          false
        ),
        [_c("ErrorAlert", { on: { hidePopup: _vm.toggleErrorPopupClose } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }